"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;








































var _user = require("@/utils/user");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Tinymce: _Tinymce.default }, data: function data() {return { addData: { aboveId: '', broadcastId: '', belowId: '', detailedId: '', above: '', broadcast: '', below: '', detailed: '' }, searchData: { insId: '' }, rules: { above: [{ required: true, message: '请输入主页上方欢迎语', trigger: 'blur' }], broadcast: [{ required: true, message: '请输入主页播报内容', trigger: 'blur' }], below: [{ required: true, message: '请输入主页下方语音指令简要说明', trigger: 'blur' }], detailed: [{ required: true, message: '请输入指令详细说明', trigger: 'blur' }] } };


  },
  mounted: function mounted() {
    var self = this;
    var orgId = self.$route.query.orgId;
    if (orgId) {
      self.searchData.insId = orgId;
    }
    this.init();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/temi/content?itemId=7&itemId=8&itemId=9&itemId=10', self.searchData, function (res) {
        for (var val in res) {
          for (var index in res[val].list) {
            var obj = res[val].list[index];
            switch (obj.itemId) {
              case 7:
                self.addData.above = obj.shortContent;
                self.addData.aboveId = obj.id;
                break;
              case 8:
                self.addData.broadcast = obj.shortContent;
                self.addData.broadcastId = obj.id;
                break;
              case 9:
                self.addData.below = obj.shortContent;
                self.addData.belowId = obj.id;
                break;
              case 10:
                self.addData.detailed = obj.longContent;
                self.addData.detailedId = obj.id;}

          }
        }
      });
    },
    checkPermission: _user.checkPermission,
    fnUploadRequest: function fnUploadRequest(option) {
      _aliOss.default.ossUploadFile(option, this.$props.path);
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          // 组装上传数据
          var uploadData = new Array(0);
          uploadData.push({ 'id': self.addData.aboveId, 'itemId': 7, 'shortContent': self.addData.above, 'isEnable': 1 });
          uploadData.push({ 'id': self.addData.broadcastId, 'itemId': 8, 'shortContent': self.addData.broadcast, 'isEnable': 1 });
          uploadData.push({ 'id': self.addData.belowId, 'itemId': 9, 'shortContent': self.addData.below, 'isEnable': 1 });
          uploadData.push({ 'id': self.addData.detailedId, 'itemId': 10, 'longContent': self.addData.detailed, 'isEnable': 1 });
          self.postData('/api/temi/content', uploadData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

          });
        } else {
          return false;
        }
      });
    } } };exports.default = _default;